import axios from 'axios';
import StatusCode from './statusCode';
import config from '../util/config';
import { refresh } from './auth.service';
import {
    getIsRefreshing,
    setIsRefreshing,
    enqueueRequestResolver,
    resolveQueuedRequests,
    rejectQueuedRequests
} from './tokenRefreshManager';

export const api = (dontUseAuthorizationHeader) => {
    const baseConfig = {
        baseURL: config.BASE_ENDPOINT_URL
    };
    const createInstance = (baseConfig) => {
        const instance = axios.create(baseConfig);
        instance.defaults.headers.common['Content-Type'] = 'application/json';
        instance.interceptors.request.use(
            async (config) => {
                if (dontUseAuthorizationHeader) return config;

                const token = await localStorage.getItem('accessToken');
                if (token && config.url !== '/login') {
                    config.headers = {
                        ...(config.headers || {}),
                        Authorization: `Bearer ${token}`
                    };
                    config.headers['Content-Type'] = 'application/json';
                }
                return config;
            },
            (error) => {
                Promise.reject(error);
            }
        );
        return instance;
    };

    const instance = createInstance(baseConfig);

    instance.interceptors.response.use(
        async (response) =>
            // const token = await localStorage.getItem("token");
            // eslint-disable-next-line max-len
            // TODO Check if token in Authorization response is different than token in local storage
            // If yes, then new access token is issued
            // If no, do nothing

            // eslint-disable-next-line implicit-arrow-linebreak
             response,
        async (error) => {
            if (error.config.url !== '/refresh') {
                const originalRequest = error.config;
                switch (error.response.status) {
                    case StatusCode.UNAUTHORIZED:
                        // Ensure only one refresh call is in-flight
                        if (!getIsRefreshing()) {
                            try {
                                setIsRefreshing(true);
                                const {
                                    data: { accessToken, refreshToken }
                                } = await refresh({
                                    accessToken: localStorage.getItem('accessToken'),
                                    refreshToken: localStorage.getItem('refreshToken')
                                });
                                localStorage.setItem('accessToken', accessToken);
                                localStorage.setItem('refreshToken', refreshToken);
                                // Retry all queued requests
                                resolveQueuedRequests();
                                return api()(originalRequest);
                            } catch (err) {
                                // Reject queued requests and force logout
                                rejectQueuedRequests(err);
                                localStorage.removeItem('accessToken');
                                localStorage.removeItem('refreshToken');
                                delete instance.defaults.headers.common.Authorization;
                                window.location.href = '/';
                            } finally {
                                setIsRefreshing(false);
                            }
                        }
                        // Queue this request to be retried after refresh completes
                        return new Promise((resolve) => {
                            enqueueRequestResolver(() => {
                                resolve(api()(originalRequest));
                            });
                        });
                        break;
                    default:
                        throw error.response;
                }
            } else /*if (error.response.status === StatusCode.UNAUTHORIZED)*/ {
                localStorage.removeItem('accessToken');
                localStorage.removeItem('refreshToken');
                delete instance.defaults.headers.common.Authorization;
                window.location.href = '/';
            }
        }
    );

    return instance;
};

export default api;
